/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Hazards-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 2/22/18
 * Copyright All Rights Reserved
 */
// @flow
import React from 'react';
import { Col, Row } from 'reactstrap';
import Footer from 'components/support/layout/Footer';
import Header from 'components/support/layout/Header';
import Main from 'components/support/layout/MainContainer';
import MainHeadingRow from 'components/support/layout/MainHeadingRow';
import Page from 'components/support/layout/Page';

const TermsPage = () => (
  <Page className="terms-page">
    <Header inApp={false} />
    <Main>
      <MainHeadingRow>
        <h1>Terms of Use</h1>
      </MainHeadingRow>
      <Row>
        <Col sm="8" className="col">
          <p>
            By accepting these terms and conditions the user hereby releases the Haselton Baker
            Risk Group, LLC, (&ldquo;HB-Risk&rdquo;) from any and all liability for any property
            damage, financial loss, or injury to persons whatsoever resulting from the direct or
            indirect use or reliance on the information presented in this software.
          </p>
          <p>
            The user recognizes that this software acts as an informative guide in the decision
            making process and that all responsibility and liability for the consequences of that
            decision lie with the user. HB-Risk does not express or imply any warranty or accept
            any liability with respect to the information provided by this software tool or the
            use thereof. The information provided in this software is not intended to, and should
            not replace the judgement of a qualified engineer.
          </p>
          <p>
            The user hereby gives HB-Risk the right to view, host, store, and analyze all
            information placed into the system by the user or any results of analyses run by the
            user or software, for the limited purpose of operating, promoting, and improving our
            products and services, and creating new products and services. Such information
            includes, but is not limited to, site information, building information, component
            fragility functions, and analysis results. Any use by HB-Risk of this information will
            be in a manner that preserves userand project anonymity.
          </p>
          <p>
            <strong>Effective</strong>: June 19, 2018
          </p>
        </Col>
      </Row>
    </Main>
    <Footer />
  </Page>
);

export default TermsPage;



// WEBPACK FOOTER //
// ./js/components/pages/Terms/index.jsx